/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    MutationFunction,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query'

import type {
    FullScreenCardsResponseDTO,
    FullScreenCardsResponseV2DTO,
    GetRequestFullScreenCardsParams,
    GetRequestV2FullScreenCardsParams,
    HTTPValidationErrorDTO,
    MessageResponseDTO,
    PostRequestFullScreenCardsDismissByCardIdParams,
} from '../../model'

import { customInstance } from '../../../customInstance'
import type { ErrorType } from '../../../customInstance'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * Dismiss full screen card

 * @summary Dismiss Full Screen Card
 */
export const postRequestFullScreenCardsDismissByCardId = (
    cardId: string,
    params: PostRequestFullScreenCardsDismissByCardIdParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<MessageResponseDTO>(
        {
            url: `/full_screen_cards/${encodeURIComponent(String(cardId))}/dismiss`,
            method: 'POST',
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestFullScreenCardsDismissByCardIdMutationOptions = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestFullScreenCardsDismissByCardId>>,
        TError,
        {
            cardId: string
            params: PostRequestFullScreenCardsDismissByCardIdParams
        },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestFullScreenCardsDismissByCardId>>,
    TError,
    { cardId: string; params: PostRequestFullScreenCardsDismissByCardIdParams },
    TContext
> => {
    const mutationKey = ['postRequestFullScreenCardsDismissByCardId']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestFullScreenCardsDismissByCardId>>,
        {
            cardId: string
            params: PostRequestFullScreenCardsDismissByCardIdParams
        }
    > = (props) => {
        const { cardId, params } = props ?? {}

        return postRequestFullScreenCardsDismissByCardId(
            cardId,
            params,
            requestOptions,
        )
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestFullScreenCardsDismissByCardIdMutationResult =
    NonNullable<
        Awaited<ReturnType<typeof postRequestFullScreenCardsDismissByCardId>>
    >

export type PostRequestFullScreenCardsDismissByCardIdMutationError =
    ErrorType<void | HTTPValidationErrorDTO>

/**
 * @summary Dismiss Full Screen Card
 */
export const usePostRequestFullScreenCardsDismissByCardId = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<typeof postRequestFullScreenCardsDismissByCardId>
            >,
            TError,
            {
                cardId: string
                params: PostRequestFullScreenCardsDismissByCardIdParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestFullScreenCardsDismissByCardId>>,
    TError,
    { cardId: string; params: PostRequestFullScreenCardsDismissByCardIdParams },
    TContext
> => {
    const mutationOptions =
        getPostRequestFullScreenCardsDismissByCardIdMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * For a user get all the full screen cards that a user should see

 * @summary Get Full Screen Cards
 */
export const getRequestFullScreenCards = (
    params: GetRequestFullScreenCardsParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<FullScreenCardsResponseDTO>(
        { url: `/full_screen_cards`, method: 'GET', params, signal },
        options,
    )
}

export const getGetRequestFullScreenCardsQueryKey = (
    params?: GetRequestFullScreenCardsParams,
) => {
    return [`/full_screen_cards`, ...(params ? [params] : [])] as const
}

export const getGetRequestFullScreenCardsQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestFullScreenCards>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestFullScreenCardsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestFullScreenCards>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey =
        queryOptions?.queryKey ?? getGetRequestFullScreenCardsQueryKey(params)

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRequestFullScreenCards>>
    > = ({ signal }) =>
        getRequestFullScreenCards(params, requestOptions, signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestFullScreenCards>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestFullScreenCardsQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestFullScreenCards>>
>
export type GetRequestFullScreenCardsQueryError =
    ErrorType<HTTPValidationErrorDTO>

export function useGetRequestFullScreenCards<
    TData = Awaited<ReturnType<typeof getRequestFullScreenCards>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestFullScreenCardsParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestFullScreenCards>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestFullScreenCards>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestFullScreenCards>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestFullScreenCards<
    TData = Awaited<ReturnType<typeof getRequestFullScreenCards>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestFullScreenCardsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestFullScreenCards>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestFullScreenCards>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestFullScreenCards>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestFullScreenCards<
    TData = Awaited<ReturnType<typeof getRequestFullScreenCards>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestFullScreenCardsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestFullScreenCards>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Get Full Screen Cards
 */

export function useGetRequestFullScreenCards<
    TData = Awaited<ReturnType<typeof getRequestFullScreenCards>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestFullScreenCardsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestFullScreenCards>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
} {
    const queryOptions = getGetRequestFullScreenCardsQueryOptions(
        params,
        options,
    )

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * @summary Get Full Screen Cards V2
 */
export const getRequestV2FullScreenCards = (
    params: GetRequestV2FullScreenCardsParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<FullScreenCardsResponseV2DTO>(
        { url: `/v2/full_screen_cards`, method: 'GET', params, signal },
        options,
    )
}

export const getGetRequestV2FullScreenCardsQueryKey = (
    params?: GetRequestV2FullScreenCardsParams,
) => {
    return [`/v2/full_screen_cards`, ...(params ? [params] : [])] as const
}

export const getGetRequestV2FullScreenCardsQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestV2FullScreenCards>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestV2FullScreenCardsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestV2FullScreenCards>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey =
        queryOptions?.queryKey ?? getGetRequestV2FullScreenCardsQueryKey(params)

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRequestV2FullScreenCards>>
    > = ({ signal }) =>
        getRequestV2FullScreenCards(params, requestOptions, signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestV2FullScreenCards>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestV2FullScreenCardsQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestV2FullScreenCards>>
>
export type GetRequestV2FullScreenCardsQueryError =
    ErrorType<HTTPValidationErrorDTO>

export function useGetRequestV2FullScreenCards<
    TData = Awaited<ReturnType<typeof getRequestV2FullScreenCards>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestV2FullScreenCardsParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestV2FullScreenCards>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestV2FullScreenCards>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestV2FullScreenCards>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestV2FullScreenCards<
    TData = Awaited<ReturnType<typeof getRequestV2FullScreenCards>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestV2FullScreenCardsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestV2FullScreenCards>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestV2FullScreenCards>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestV2FullScreenCards>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestV2FullScreenCards<
    TData = Awaited<ReturnType<typeof getRequestV2FullScreenCards>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestV2FullScreenCardsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestV2FullScreenCards>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Get Full Screen Cards V2
 */

export function useGetRequestV2FullScreenCards<
    TData = Awaited<ReturnType<typeof getRequestV2FullScreenCards>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestV2FullScreenCardsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestV2FullScreenCards>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
} {
    const queryOptions = getGetRequestV2FullScreenCardsQueryOptions(
        params,
        options,
    )

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> }

    query.queryKey = queryOptions.queryKey

    return query
}
